/* ========================================================================
 Add custom js in here, coz I'm worth it
 * ======================================================================== */

 /**
   * Nice code pen on showing and hiding divs http://jsfiddle.net/axl163/ukrbnb3n/?utm_source=website&utm_medium=embed&utm_campaign=ukrbnb3n
  **/

 var $ = jQuery.noConflict();
 // $('.excerpt-wrap').hide(); /* hide the excerpt div */
 $('.bottom').hide();
 $('.top').on('click', function() {
 	$parent_box = $(this).closest('ul');
 	$parent_box.find('.bottom').slideToggle(500, 'swing');
 });

 $('.top').on('click', function() {
     $(this).closest('li').toggleClass("arrow-down");
 });
